import { countries } from './countryCodes';
export const user_fields = () => [
  {
    key: 'name',
    type: 'text',
    validation: (value) => {
      if (!value) return true;
      else false;
    },
    placeHolder: 'Ad*',
    defaultValue: null,
  },
  {
    key: 'surname',
    type: 'text',
    validation: (value) => {
      if (!value) return true;
      else false;
    },
    placeHolder: 'Soyad*',
    defaultValue: null,
  },
  {
    key: 'username',
    type: 'text',
    validation: (value) => {
      if (!value) return true;
      else false;
    },
    placeHolder: 'Kullanıcı Adı*',
    defaultValue: null,
  },
  {
    key: 'password',
    type: 'text',
    inputType: 'password',
    validation: (value) => {
      if (!value) return true;
      else false;
    },
    placeHolder: 'Parola*',
    defaultValue: null,
  },
  // {
  //   key: 'email',
  //   type: 'text',
  //   inputType: 'email',
  //   validation: (value) => {
  //     if (!value) return true;
  //     else false;
  //   },
  //   placeHolder: 'E Posta*',
  //   defaultValue: null,
  // },
  {
    key: 'phone',
    type: 'text',
    validation: (value) => {
      if (!value) return true;
      else false;
    },
    placeHolder: 'Telefon Numarası',
    defaultValue: null,
  },
];
